import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/Button';

export const EmailForm: React.FC = () => {
  const { t } = useLanguage();
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new FormData(form);
    
    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: data,
        headers: {
          'Accept': 'application/json'
        }
      });
      if (response.ok) {
        setSubmitted(true);
      }
    } catch (error) {
      console.error("Form submission error", error);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="font-mono text-emerald text-sm py-3 px-6 border border-emerald/30 bg-emerald/5 inline-block">
        {t.form.success}
      </div>
    );
  }

  return (
    <form 
      action="https://formspree.io/f/xgopkzwq" 
      method="POST" 
      onSubmit={handleSubmit}
      className="flex flex-col sm:flex-row gap-3 w-full max-w-3xl"
    >
      <input type="hidden" name="_subject" value="Nuova richiesta audit — gguacci.com" />
      
      <input 
        type="text" 
        name="name" 
        placeholder={t.form.name} 
        required 
        className="flex-1 bg-transparent border border-white/20 text-white font-light text-sm px-4 py-3 focus:outline-none focus:border-emerald transition-colors min-w-0"
      />
      
      <input 
        type="text" 
        name="brand" 
        placeholder={t.form.brand} 
        required 
        className="flex-1 bg-transparent border border-white/20 text-white font-light text-sm px-4 py-3 focus:outline-none focus:border-emerald transition-colors min-w-0"
      />
      
      <input 
        type="email" 
        name="email" 
        placeholder={t.form.email} 
        required 
        className="flex-1 bg-transparent border border-white/20 text-white font-light text-sm px-4 py-3 focus:outline-none focus:border-emerald transition-colors min-w-0"
      />
      
      <Button type="submit" className="whitespace-nowrap" disabled={loading}>
        {loading ? '...' : t.form.submit}
      </Button>
    </form>
  );
};
